
import React, { useEffect, createContext, useMemo, useState } from 'react';
import { decodeToken } from "react-jwt"

import { fnChangeCostumer, getUser, logout } from "../services/auth";
import useDataApi from '../hooks/useDataApi';
import { C_SELECTED_PANELS_STORAGE_KEY } from "./Paineis"
import { fnDecodeStorageToken } from "../utils/encodeLocalStorage";
import { useParams } from 'react-router-dom';

export function fnCleanStorage() {
    localStorage.removeItem('cAccessToken');
    localStorage.removeItem("cStorageToken");

    sessionStorage.removeItem('nCustId');
    sessionStorage.removeItem('cOldCompanyName');
    sessionStorage.removeItem(C_SELECTED_PANELS_STORAGE_KEY);
}

export const AuthContext = createContext(null);

export const AuthContextProvider = ({ children }) => {
    const [oUserRes, fnFetchUser] = useDataApi(getUser);
    const [oChangeCostumerRes, fnChangeCostumerReq] = useDataApi(fnChangeCostumer)
    const [oUser, fnSetOUser] = useState({ data: null })
    const { blockId } = useParams()
    useEffect(() => {
        (async () => {
            await fnReloadUser()
        })();
    }, []);

    const fnLogout = async () => {
        await logout();
        fnCleanStorage();
        if (window.location.pathname !== "/") {
            window.location.href = "/";
        }
    }

    const fnReloadUser = async () => {
        const nUserId = fnDecodeStorageToken()?.nUserId
        if (blockId && !nUserId && !localStorage.getItem("qrCodeUrl")) {
            localStorage.setItem("qrCodeUrl", window.location.pathname)
        }
        if (oUserRes?.loading || !nUserId) return
        const response = await fnFetchUser(nUserId)

        const oDecodedToken = decodeToken(response)
        fnSetOUser({ data: oDecodedToken.oUser })
    }

    const value = useMemo(() => {
        return { oUser, fnLogout, fnChangeCostumerReq, oChangeCostumerRes, fnReloadUser };
    }, [oUser, oChangeCostumerRes]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
